// @flow
import levenshtein from 'app/packages/levenshtein';

// A gmail address is considered to be mistyped if:
// - If the first part of the domain is gmail and the second part is NOT com
// - The domain starts with a g and is off by 1 or 2 typo counts (calculated by levenshtein distance)
export default function isMistypedGmail(email: string) {
  const splitEmail = email && email.indexOf('@') !== -1 ? email.split('@') : [];
  if (splitEmail.length === 2) {
    const domain = splitEmail[1];
    const splitDomain = domain && domain.indexOf('.') !== -1 ? domain.split('.') : [];
    if (
      splitDomain.length >= 2 &&
      splitDomain[0] === 'gmail' &&
      splitDomain.slice(1).join('.') !== 'com'
    ) {
      return true;
    }
    const typoCount = levenshtein(domain, 'gmail.com');
    if (domain.charAt(0) === 'g' && (typoCount === 1 || typoCount === 2)) {
      return true;
    }
  }
  return false;
}
